// extracted by mini-css-extract-plugin
export default {"description":"QHeG-","form":"-Em8i"};